// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format32 } from '../../constants';

/** Japan */
const JP: PhoneNumberData = [81, 'JP', 10, format32];

export default JP;
